import React, { useState } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import BankSuggestionBox from '../CommonComp/BankSuggestionBox';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';

const parseFilterDate = (value) => {
    if (!value) return null;
    const parts = String(value).split('/');
    if (parts.length !== 3) return null;
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (!month || !day || !year) return null;
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
};

const BankLedger = () => {
    const accessToken = localStorage.getItem('accessToken');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [reportrange, setReportrange] = useState('');
    const [bank, setBank] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [bankInfo, setBankInfo] = useState({
        bank_name: '',
        account_name: '',
        account_no: '',
        sort_code: '',
        currency: '',
    });
    const [summary, setSummary] = useState({
        total_debit: '0.00',
        total_credit: '0.00',
        difference: '0.00',
        is_balanced: true,
        opening_balance: '0.00',
        closing_balance: '0.00',
    });
    const [ledgerRows, setLedgerRows] = useState([]);
    const [periodLabel, setPeriodLabel] = useState('');

    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [start, end] = dates;
            setFromDate(format(start, 'MM/dd/yyyy'));
            setToDate(format(end, 'MM/dd/yyyy'));
            setReportrange(`${format(start, 'dd/MM/yyyy')} - ${format(end, 'dd/MM/yyyy')}`);
        } else if (!dates) {
            setFromDate('');
            setToDate('');
            setReportrange('');
        }
    };

    const handleSearch = async () => {
        if (!bank?.value) {
            setMessage('Please select bank');
            return;
        }
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }
        setLoading(true);
        setMessage('');
        const formData = new FormData();
        formData.append('bank_id', bank.value);
        formData.append('start_date', fromDate);
        formData.append('end_date', toDate);
        try {
            const response = await fetch(`${config.api_url}/get_bank_ladger`, {
                method: 'POST',
                headers: { authorization: `Bearer ${accessToken}` },
                body: formData,
            });
            const json = await response.json();
            if (!json.success || !json.data || !json.data.bank) {
                setBankInfo({
                    bank_name: '',
                    account_name: '',
                    account_no: '',
                    sort_code: '',
                    currency: '',
                });
                setLedgerRows([]);
                setSummary({
                    total_debit: '0.00',
                    total_credit: '0.00',
                    difference: '0.00',
                    is_balanced: true,
                    opening_balance: '0.00',
                    closing_balance: '0.00',
                });
                setPeriodLabel('');
                setMessage(json.message || 'No transaction available for selected criteria.');
                return;
            }
            const data = json.data;
            setBankInfo({
                bank_name: data.bank?.bank_name || '',
                account_name: data.bank?.account_name || '',
                account_no: data.bank?.account_no || '',
                sort_code: data.bank?.sort_code || '',
                currency: data.bank?.currency || '',
            });
            setSummary({
                total_debit: data.summary?.total_debit || '0.00',
                total_credit: data.summary?.total_credit || '0.00',
                difference: data.summary?.difference || data.summary?.closing_balance || '0.00',
                is_balanced:
                    typeof data.summary?.is_balanced === 'boolean'
                        ? data.summary.is_balanced
                        : true,
                opening_balance: data.summary?.opening_balance || '0.00',
                closing_balance: data.summary?.closing_balance || '0.00',
            });
            setLedgerRows(Array.isArray(data.bank_ledger) ? data.bank_ledger : []);
            setPeriodLabel(
                data.start_date && data.end_date ? `${data.start_date} - ${data.end_date}` : reportrange
            );
            setMessage(
                data.bank_ledger && data.bank_ledger.length > 0
                    ? ''
                    : 'No transaction available for selected period.'
            );
        } catch {
            setMessage('Failed to load bank ledger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;{' '}
                            <a href="/Dashboard">Dashboard</a> &gt;{' '}
                            <span className="last-crumb">Bank Ledger</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="container-fluid">
                    <div className="show-order-area dashboard account-ledger-page">
                        <div className="account-ledger-toolbar">
                            <div className="dashform">
                                <div className="topsearch-area sales-ledger-filters">
                                    <div className="row g-2 g-lg-3 align-items-end">
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <label className="col-form-label">Bank</label>
                                            <BankSuggestionBox onBankChange={setBank} />
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-4">
                                            <label className="col-form-label">Date Range</label>
                                            <DateRangePicker
                                                format="dd/MM/yyyy"
                                                editable={false}
                                                cleanable
                                                placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                                style={{ width: '100%' }}
                                                value={[
                                                    parseFilterDate(fromDate),
                                                    parseFilterDate(toDate),
                                                ]}
                                                onChange={handleDateChange}
                                                onClean={() => {
                                                    setFromDate('');
                                                    setToDate('');
                                                    setReportrange('');
                                                }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 col-xl-2">
                                            <button
                                                type="button"
                                                className="btn btn-primary w-100"
                                                onClick={handleSearch}
                                                disabled={loading}
                                            >
                                                {loading ? 'Loading...' : 'Search'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="account-ledger-results">
                        {message ? (
                            <div className="alert alert-warning mt-3" role="alert">
                                {message}
                            </div>
                        ) : null}
                        {bankInfo.bank_name ? (
                            <div className="mt-3 mb-2">
                                <strong>
                                    {bankInfo.bank_name}
                                    {bankInfo.account_no ? ` (${bankInfo.account_no})` : ''}
                                </strong>
                                {bankInfo.account_name ? (
                                    <span className="ms-3">Account: {bankInfo.account_name}</span>
                                ) : null}
                                {bankInfo.currency ? (
                                    <span className="ms-3">Currency: {bankInfo.currency}</span>
                                ) : null}
                                {periodLabel ? (
                                    <span className="ms-3">Period: {periodLabel}</span>
                                ) : null}
                            </div>
                        ) : null}
                        {bankInfo.bank_name ? (
                            <div className="verical-scrl-wrapper common-table account-ledger-summary mb-3">
                                <table className="table table-bordered dataTable">
                                    <thead>
                                        <tr>
                                            <th>Total Debit</th>
                                            <th>Total Credit</th>
                                            <th>Difference</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-end">{summary.total_debit}</td>
                                            <td className="text-end">{summary.total_credit}</td>
                                            <td className="text-end">{summary.difference}</td>
                                            <td>
                                                {summary.is_balanced ? 'Balanced' : 'Not Balanced'}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                        <div className="verical-scrl-wrapper common-table account-ledger-table-scroll">
                            <table className="table table-bordered dataTable">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Date</th>
                                        <th>Ref No</th>
                                        <th>Party</th>
                                        <th>Type</th>
                                        <th className="text-end">Debit</th>
                                        <th className="text-end">Credit</th>
                                        <th className="text-end">Balance</th>
                                        <th>Transaction Ref</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ledgerRows.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                No transaction available
                                            </td>
                                        </tr>
                                    ) : (
                                        ledgerRows.map((row, index) => (
                                                <tr
                                                    key={row.ledger_id || index}
                                                    className={row.is_payment ? 'account-ledger-payment-row' : ''}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{row.date}</td>
                                                    <td>{row.ref_no}</td>
                                                    <td>{row.party_name}</td>
                                                    <td>{row.type}</td>
                                                    <td className="text-end">{row.debit}</td>
                                                    <td className="text-end">{row.credit}</td>
                                                    <td className="text-end">{row.balance}</td>
                                                    <td>{row.transaction_ref}</td>
                                                </tr>
                                            ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BankLedger;
